<template>
   <v-app>
    <nav-bar v-if="!$route.meta.hideNavbar"  />
    <vue-snotify></vue-snotify>
    <v-main>
    <router-view/>
    </v-main>
   </v-app>
</template>
<script>
import NavBar from "./components/layout/NavBar.vue";
export default {
  components: { NavBar },
  name: "App",
};
</script>
<style>
.coloryellow {
  background-color: #ffffb3 !important;
}
.colorblue {
  background-color: #9fcfff !important;
}
.colorgreen {
  background-color: #9bff9b !important;
}
.colorgrey {
  background-color: #d1d1d1 !important;
}
.colorred {
  background-color: #ffc9ae !important;
}
</style>
